import { Injectable, Inject, Optional } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AIConfig, DEFAULT_CONFIG } from '../models/ai-config.interface';
import { AI_CONFIG } from '../ai-assistant.config';

@Injectable({
  providedIn: 'root',
})
export class AIAssistantService {
  private config: AIConfig;
  private isOpenSubject = new BehaviorSubject<boolean>(false);

  isOpen$ = this.isOpenSubject.asObservable();

  constructor(@Optional() @Inject(AI_CONFIG) configFromToken: AIConfig | null) {
    this.config = configFromToken || DEFAULT_CONFIG;

    // Check for global config and merge with defaults
    if (window['AIConfig']) {
      this.updateConfig(window['AIConfig']);
    }
  }

  getConfig(): AIConfig {
    return { ...this.config };
  }

  updateConfig(newConfig: Partial<AIConfig>): void {
    this.config = { ...this.config, ...newConfig };
  }

  open(): void {
    this.isOpenSubject.next(true);
  }

  close(): void {
    this.isOpenSubject.next(false);
  }

  toggle(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }
}
